export const base = 'font-noto-ikea';

const regularVariant = {
  m: 'text-link-m underline',
  s: 'text-link-s underline',
  xs: 'text-link-xs underline',
};

const boldVariant = {
  m: 'text-link-m-bold underline',
  s: 'text-link-s-bold underline',
  xs: 'text-link-nav',
};

export const variant = (bold?: boolean) => (bold ? boldVariant : regularVariant);
